<template>
  <div class="callback-loading">
    <depa-bird :size="64" flap hover></depa-bird>
    <div class="callback-text">กำลังเข้าสู่ระบบ...</div>
  </div>
</template>
<script>
import axios from "axios";
import DepaBird from '../components/DepaBird.vue';
import { API_URL } from '@/config';
import Swal from 'sweetalert2';
import { mapActions } from 'vuex';
import { consumeAzureState } from '@/auth/azure';
import { queueGreeting } from '@/fun/greetingToast';

export default {
  name: 'CallbackAzure',
  components: { DepaBird },
  async mounted() {
    const { code, state, error } = this.$route.query;
    if (!consumeAzureState(state)) {
      this.$router.replace('/login');
      return;
    }
    if (error || !code) {
      this.fail();
      return;
    }
    try {
      const res = await axios.get(`${API_URL}/loginAzure`, { params: { code } });
      if (res.data.responsecode === 200) {
        await this.setSession({ user: res.data.user, token: res.data.token });
        queueGreeting();
        this.$router.replace('/dashboard');
      } else {
        this.fail(res.data.responsecode === 403 ? 'บัญชีนี้ถูกปิดการใช้งาน' : undefined);
      }
    } catch (e) {
      console.error(e.message);
      this.fail();
    }
  },
  methods: {
    ...mapActions(['setSession']),
    fail(text) {
      Swal.fire({
        title: "เข้าสู่ระบบไม่สำเร็จ",
        text,
        icon: "warning",
        confirmButtonText: '<span style="padding: 15px" >ปิด</span>',
      });
      this.$router.replace('/login');
    },
  },
};
</script>

<style scoped>
.callback-loading {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #0C2F53 0%, #123E6B 100%);
}

.callback-text {
  margin-top: 16px;
  color: #FFFFFF;
  font-size: 17px;
  font-weight: 600;
}
</style>
